import { render, staticRenderFns } from "./ProfileVerification.vue?vue&type=template&id=5788daa9"
import script from "./ProfileVerification.vue?vue&type=script&lang=js"
export * from "./ProfileVerification.vue?vue&type=script&lang=js"
import style0 from "./ProfileVerification.vue?vue&type=style&index=0&id=5788daa9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports